<template>
  <div class="container">
    <!-- 第一部分：成功提示 -->
    <div class="success-section">
      <div class="success-title">{{application_type_show}}</div>
      <div class="success-child-title">请在前台出示您的有效证件和车票信息</div>
      <div class="success-child-title">工作人员会尽快为您安排座位</div>
    </div>
    <div class="content-card">
        <!-- 表单区域 -->
        <div class="form-container">
          <van-field
            label="姓名"
            label-width="100px"
            :value="formData.name"
            readonly
          />
          <van-field
            label="证件类型"
            label-width="100px"
            :value="formData.cardTypeShow"
            readonly
          />
          <van-field
            label="证件号"
            label-width="100px"
            :value="formData.idNumber"
            readonly
          />
          <van-field
            label="手机号"
            label-width="100px"
            :value="formData.tel"
            readonly
          />

          <van-field
            label="性别"
            label-width="100px"
            :value="formData.genderShow"
            readonly
          />
          <van-field
            label="车次"
            label-width="100px"
            :value="formData.trainNumber"
            readonly
          />
          {{ application_type }}
          <van-field
            label="预约入住时间"
            label-width="100px"
            :value="formData.appointmentTime"
            readonly
            v-if="application_portal==='1'"
          >
          </van-field>
          <van-field
            label="出发时间"
            label-width="100px"
            :value="formData.formattedTime"
            readonly
          >
          </van-field>
        <van-field
            label="出发站"
            label-width="100px"
            v-model="formData.start_station_name"
            readonly
          >
        </van-field>
        <van-field
            label="到达站"
            label-width="100px"
            v-model="formData.end_station_name"
            readonly
          >
        </van-field>
          <!-- <van-field
            name="have_children"
            label-width="1px"
          >
            <template #input>
              <van-checkbox 
                v-model="formData.have_children" 
                shape="square"
                checked-color="#07c160"
                disabled
              >
                带小孩出行
              </van-checkbox>
            </template>
          </van-field> -->
        </div>
      </div>
    <!-- <van-button
      type="info" 
      class="submit-btn"
      @click="handleReturn"
    >
    返回填写
    </van-button> -->

    <!-- 第三部分：温馨提示 -->
    <div class="notice-section">
      <div class="notice-title">温馨提示：</div>
      <div class="notice-content">请在预约入住时间后30分钟内，到达前台登记，逾期将取消预约</div>
    </div>
     <evaluation-form @submit-success="onEvaluationSubmit" />
  </div>
</template>

<script>
import EvaluationForm from '../components/EvaluationForm.vue';
export default {
  components: { EvaluationForm },
  data() {
    return {
      application_type_show:'',
      application_portal:'',
      formData: {
        name: '',
        cardType:'',
        cardTypeShow:'',
        sqType:'',
        sqTypeShow:'',
        idNumber: '',
        tel:'',
        start_station_name: '',
        end_station_name: '',
        gender: '',
        genderShow: '',
        trainNumber: '',
        formattedTime: '',
        appointmentTime: '',
        have_children: false,
      },
      genderOptions: [
        { label: '男', value: '0' },
        { label: '女', value: '1' },
      ],
      sqOptions: [
        { label: '出发', value: '1' },
        { label: '到达', value: '2' },
        { label: '中转换乘', value: '3' },
      ],
      cardTypeOptions: [
        { label: '身份证', value: '1' },
        { label: '护照', value: '2' },
        { label: '军官证', value: '3' },
        { label: '学生证', value: '4' },
      ]
    };
  },
  computed: {
    cardTypeMap() {
      const map = new Map();
      this.cardTypeOptions.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    },
    sqTypeMap() {
      const map = new Map();
      this.sqOptions.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    },
    genderTypeMap() {
      const map = new Map();
      this.genderOptions.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    },
    
  },
  mounted() {
    const query = this.$route.query;
    const name = decodeURIComponent(query.name);
    const cardType = decodeURIComponent(query.cardType);
    const cardTypeShow = this.getLabelByValue(cardType);
    const sqType = decodeURIComponent(query.sqType);
    const sqTypeShow = this.getSqLabelByValue(sqType);
    const idNumber = decodeURIComponent(query.idNumber);
    const tel = decodeURIComponent(query.tel);
    const trainNumber = decodeURIComponent(query.trainNumber);
    const gender = decodeURIComponent(query.gender);
    const genderShow = this.getGenderLabelByValue(gender);
    const start_station_name = decodeURIComponent(query.start_station_name);
    const end_station_name = decodeURIComponent(query.end_station_name);
    const formattedTime = decodeURIComponent(query.formattedTime);
    const appointmentTime = decodeURIComponent(query.appointmentTime);
    const have_children = query.have_children;
    const application_type_show = query.application_type==="1"?"您已预约":"提交成功";
    this.application_portal = query.application_portal;
    this.formData = { name,cardType,cardTypeShow,sqType,sqTypeShow,tel, idNumber, start_station_name,end_station_name, gender,genderShow,trainNumber, formattedTime,appointmentTime,have_children };
  },
  methods: {
    getLabelByValue(value) {
      return this.cardTypeMap.get(value) || value;
    },
    getSqLabelByValue(value) {
      return this.sqTypeMap.get(value) || value;
    },
    getGenderLabelByValue(value) {
      return this.genderTypeMap.get(value) || value;
    },
    handleReturn() {
      var that = this;
      this.$router.push({
        path: '/'
      });
    },
     onEvaluationSubmit(submitData) {
      // 处理评价提交成功后的逻辑，如刷新评价列表等
      console.log('收到评价数据:', submitData);
    }
  }
};
</script>

<style scoped>
/* 背景渐变 */
.container {
  background: linear-gradient(180deg, #85b1f6 0%, #E0F6FF 100%);
  min-height: 100vh;
  padding: 40px 2.5px;
}

/* 成功信息模块 */
.success-section {
  text-align: center;
  text-shadow: 
    2rpx 2rpx 4rpx rgba(0,0,0,0.3), /* 基础阴影 */
    0 0 10rpx rgba(255,0,0,0.2);   /* 霓虹光效 */
}

.success-title {
  font-size: 30px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 12px;
}
.success-child-title {
  font-size: 18px;
  font-weight: 700;
  color: #d83642;
  margin-bottom: 12px;
}

.info-row {
  font-size: 24px;
  color: #d83642;
  line-height: 1.8;
}

.highlight {
  font-size: 24px;
  color: #FFD700;
  line-height: 1.8;
  font-weight: 500;
  text-align: left;
}

/* 车票卡片 */
.ticket-card {
  background: #FFFFFF;
  border-radius: 25px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  width: 90%;
  margin: 0px auto 0;
  overflow: hidden;
}

.card-content {
  padding: 16px;
}

/* 行程信息布局 */
.trip-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.station-name {
  font-size: 16px;
  font-weight: 500;
  color: #8a7f80;
  margin-bottom: 6px;
}

.time {
  font-size: 35px;
  color: #222;
  margin-bottom: 4px;
}

.date {
  font-size: 12px;
  color: #666;
}

.trip-middle {
  flex: 0 0 90px;
  text-align: center;
  padding-top: 14px;
}

.train-number {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.duration {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}

/* 温馨提示 */
.notice-section {
  margin-left: 20px;
  margin-top: 20px;
  text-align: left;
  font-size: 14px;
  color: #FF4444;
}

.notice-title {
  color: #FF4444;
  font-size: 14px;
  font-weight: bold;
}

.notice-content {
  color: #FF4444;
  font-size: 13px;
  line-height: 1.6;
}
.submit-btn {
  border-radius: 5px !important;
  background: #2275ff !important;
  box-shadow: 0 2px 8px rgba(9, 94, 180, 0.3);
  width: 125px !important;
  margin: 10px;
}

.content-card {
  position: relative;
  margin: 15px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  z-index: 1;
}


.form-container {
  padding: 0 20px;
}
</style>